document.addEventListener('DOMContentLoaded', (e) => {

	const blocks = document.querySelectorAll('.block--simple-accordion');

	// Group accordions by their parent row
	function getAccordionGroups() {
		const groups = new Map();
		blocks.forEach(block => {
			// Find the row ancestor (Bootstrap row or flex container)
			const row = block.closest('.row, [class*="wp-block-columns"]');
			if (row) {
				if (!groups.has(row)) {
					groups.set(row, []);
				}
				groups.get(row).push(block);
			}
		});
		return groups;
	}

	// Check if accordions are side by side (not wrapped/stacked)
	function areAccordionsSideBySide(accordions) {
		if (accordions.length < 2) return false;

		// Check if parent columns are at 100% width (stacked)
		const firstAcc = accordions[0];
		const column = firstAcc.closest('.wp-block-column, .col, [class*="col-"]');

		if (column) {
			const columnStyle = window.getComputedStyle(column);
			const flexBasis = columnStyle.flexBasis;
			const maxWidth = columnStyle.maxWidth;

			// If flex-basis is 100% or max-width is 100%, columns are stacked
			if (flexBasis === '100%' || maxWidth === '100%') {
				return false;
			}
		}

		// Fallback: check left positions
		const lefts = accordions.map(acc => acc.getBoundingClientRect().left);
		const firstLeft = lefts[0];
		const allSameLeft = lefts.every(left => Math.abs(left - firstLeft) < 10);

		return !allSameLeft;
	}

	// Set equal heights for collapsed accordions in a row
	function setEqualHeights(accordions) {
		// Reset heights first
		accordions.forEach(acc => {
			acc.style.minHeight = '';
		});

		// Skip equal heights when columns are stacked/wrapped
		if (!areAccordionsSideBySide(accordions)) {
			return;
		}

		// Get heights of collapsed accordions only
		let maxHeight = 0;
		accordions.forEach(acc => {
			const isExpanded = acc.querySelector('.accordion-collapse.show');
			if (!isExpanded) {
				const height = acc.offsetHeight;
				if (height > maxHeight) {
					maxHeight = height;
				}
			}
		});

		// Apply min-height to all accordions
		if (maxHeight > 0) {
			accordions.forEach(acc => {
				acc.style.minHeight = maxHeight + 'px';
			});
		}
	}

	// Update column alignment when accordion expands/collapses
	function updateColumnAlignment(block, isExpanding) {
		const column = block.closest('.col, .wp-block-column, [class*="col-"]');
		if (column) {
			if (isExpanding) {
				column.style.alignSelf = 'flex-start';
			} else {
				column.style.alignSelf = '';
			}
		}
	}

	function create_block_simple_accordion() {

		return {
			block: null,

			init: function (block) {
				this.block = block;
				this.setupBootstrapCollapse();
			},

			setupBootstrapCollapse: function() {
				const button = this.block.querySelector('.accordion-button');
				const collapse = this.block.querySelector('.accordion-collapse');
				const block = this.block;

				if (button && collapse) {
					collapse.addEventListener('show.bs.collapse', () => {
						button.classList.remove('collapsed');
						button.setAttribute('aria-expanded', 'true');
						updateColumnAlignment(block, true);
					});

					collapse.addEventListener('hide.bs.collapse', () => {
						button.classList.add('collapsed');
						button.setAttribute('aria-expanded', 'false');
						updateColumnAlignment(block, false);
					});
				}
			},

			log: (message) => {
				console.log(message);
			}
		}
	}

	blocks.forEach(block => {
		const block_simple_accordion = create_block_simple_accordion();
		block_simple_accordion.init(block);
	});

	// Initialize equal heights for each row group (with delay to ensure CSS is applied)
	const groups = getAccordionGroups();

	// Wait for layout to be calculated
	requestAnimationFrame(() => {
		groups.forEach((accordions, row) => {
			// Set initial equal heights
			setEqualHeights(accordions);

		// Update heights when any accordion in the group expands/collapses
			accordions.forEach(acc => {
				const collapse = acc.querySelector('.accordion-collapse');
				if (collapse) {
					collapse.addEventListener('shown.bs.collapse', () => {
						setEqualHeights(accordions);
					});
					collapse.addEventListener('hidden.bs.collapse', () => {
						setEqualHeights(accordions);
					});
				}
			});
		});
	});

	// Recalculate on window resize
	let resizeTimeout;
	window.addEventListener('resize', () => {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(() => {
			groups.forEach((accordions) => {
				setEqualHeights(accordions);
			});
		}, 100);
	});
});